import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import API from '../api'
import templates from './modules/templates'
import stages from './modules/stages'
import campaigns from './modules/campaigns'
import mailLogs from './modules/mail_logs'
import mailQueues from './modules/mail_queues'
import campaignCategories from './modules/campaign_categories'
import filters from './modules/filters'
import substitutionTags from './modules/substitution_tags'
import applications from './modules/applications'
import contacts from './modules/contacts'
import emails from './modules/emails'

Vue.use(Vuex)

// TODO: make configurable
// const fakeApiUrl = process.env.VUE_APP_FAKE_API_URL
const pageSize = 20

export const api = new API()

api.loadingCallback = (isLoading, loaders) => {
  store.commit('updateLoading', isLoading)
}

api.unauthorizedCallback = () => {
  store.dispatch('logout')
}

const store = new Vuex.Store({
  modules: {
    templates,
    stages,
    campaigns,
    mail_logs: mailLogs,
    mail_queues: mailQueues,
    campaign_categories: campaignCategories,
    filters,
    substitution_tags: substitutionTags,
    applications,
    contacts,
    emails
  },

  state: {
    isLoading: false,
    campaignHistory: [],
    campaignHistoryPage: 0,
    campaignHistoryPageSize: pageSize,
    campaignHistoryTotal: 0,
    userToken: null,
    referrer: '',
    redirect: '/campaigns'
  },

  mutations: {
    updateAttribute(state, { attribute, value }) {
      state[attribute] = value
    },

    updateLoading(state, value) {
      state.isLoading = value
    }
  },

  actions: {
    async login({ commit, state }, { email, password }) {
      let [jwt] = await api.auth.login(email, password)
      let expires = moment().add(1, 'years').toString()
      let name = process.env.VUE_APP_JWT_COOKIE_NAME || 'user_token'
      let domain = process.env.VUE_APP_JWT_COOKIE_DOMAIN || 'oscarcrm.com'

      document.cookie = `${name}=${jwt.access_token}; Expires=${expires}; Path=/; Domain=${domain}`
      api.authToken = jwt.access_token
      commit('updateAttribute', { attribute: 'userToken', value: jwt.access_token })
    },

    logout({ commit, state }) {
      // delete cookie by setting expiration to an older date
      let expires = moment().min().toString()
      let name = process.env.VUE_APP_JWT_COOKIE_NAME || 'user_token'
      let domain = process.env.VUE_APP_JWT_COOKIE_DOMAIN || 'oscarcrm.com'

      document.cookie = `${name}=; Expires=${expires}; Path=/; Domain=${domain}`

      api.authToken = null
      commit('updateAttribute', { attribute: 'userToken', value: null })

      location.reload()
    },

    // DO NOT CALL, FOR TESTING ONLY
    mangleUserToken({ commit, state }) {
      // junk user token that expired a long time ago, to test 401 responses from the API
      let badToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJleHAiOjE1MTEwMDAwMDB9.J13ehcjfVU7vt53ukw6nO-uMy2CRKRg0IzaOnSkGa-4'
      let expires = moment().add(1, 'years').toString()
      let name = process.env.VUE_APP_JWT_COOKIE_NAME || 'user_token'
      let domain = process.env.VUE_APP_JWT_COOKIE_DOMAIN || 'oscarcrm.com'

      document.cookie = `${name}=${badToken}; Expires=${expires}; Path=/; Domain=${domain}`
      api.authToken = badToken
      commit('updateAttribute', { attribute: 'userToken', value: badToken })
    },

    // restores a jwt from local storage, returns null if key doesn't exist
    restoreUser({ commit, state }) {
      let name = process.env.VUE_APP_JWT_COOKIE_NAME || 'user_token'
      let regex = new RegExp(`${name}=([A-Za-z0-9-_=]+\\.[A-Za-z0-9-_=]+\\.?[A-Za-z0-9-_.+/=]+)`)
      let match = document.cookie.match(regex)
      let token = match ? match[1] : null

      api.authToken = token
      commit('updateAttribute', { attribute: 'userToken', value: token })
    }
  }
})

export default store
